export function equalsZero(value) {
  if (value === "0.0" || value === "0,0") return true;
  if (value === 0) return true;
  else return false;
}
